import type { Rule } from "../types";
import { makeFiring } from "../util";
import { toIsoDate } from "../util";

const EVIDENCE = "kreider_2017_creatine";

/**
 * Active creatine supplement not logged today by 14:00 local. Kreider 2017
 * (ISSN position stand): 3-5 g/day creatine monohydrate — adherence matters
 * more than timing, but the daily-dose habit is what produces the saturation
 * effect.
 */
function isCreatine(name: string): boolean {
  return /creatine/i.test(name);
}

export const creatineSkippedToday: Rule = {
  id: "creatine_missed_today",
  domain: "health.nutrition",
  topics: ["creatine", "supplementation"],
  evidence_refs: [EVIDENCE],
  title: () => "Creatine not logged today",
  evaluate(ctx) {
    const active = ctx.supplements.filter(
      (s) => isCreatine(s.name) && s.status === "active",
    );
    if (active.length === 0) return null;
    if (ctx.now.getHours() < 14) return null;

    const today = toIsoDate(ctx.now);
    const takenToday = ctx.supplement_intakes.some((i) => {
      const supp = active.find((a) => a.id === i.supplement_id);
      return supp && i.taken_at.startsWith(today);
    });
    if (takenToday) return null;

    return makeFiring({
      rule_id: "creatine_missed_today",
      now: ctx.now,
      tz: ctx.tz,
      severity: "neutral",
      message: `Creatine not logged yet today. Daily dose drives the muscle saturation that does the work.`,
      evidence_refs: [EVIDENCE],
      factors: [
        {
          name: "creatine_missed_today",
          value: "true",
          contribution: "log dose",
          evidence_ref: EVIDENCE,
        },
      ],
      target_surface: "today",
      target_action: { kind: "open_supplement_log" },
    });
  },
};
